import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';
import { fr } from './locales/fr.js';
import { ar } from './locales/ar.js';

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    debug: true, // pratique pour voir les événements dans la console pendant le développement
    lng: localStorage.getItem('language') || 'fr',
    fallbackLng: 'fr',
    resources: {
      ar: {
        translations: ar,
      },
      fr: {
        translations: fr,
      },
    },
  });

export function getLangDir() {
  return document.documentElement.lang === 'ar' ? 'RTL' : 'LTR';
}

export default i18n;
